// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header__header___Ms3oi {
    display: grid;
    grid-template: 'left center right';
    grid-template-columns: repeat(3, 1fr);

    width: 100%;
    height: 4rem;
    padding: var(--space-xs);
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Template/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kCAAkC;IAClC,qCAAqC;;IAErC,WAAW;IACX,YAAY;IACZ,wBAAwB;AAC5B","sourcesContent":[".header {\n    display: grid;\n    grid-template: 'left center right';\n    grid-template-columns: repeat(3, 1fr);\n\n    width: 100%;\n    height: 4rem;\n    padding: var(--space-xs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header__header___Ms3oi`
};
export default ___CSS_LOADER_EXPORT___;
